import React, { useState, useEffect, useRef } from "react";
import axios from "axios";
import Groceryandbeveragesadvertise from "../Grocery/pages/Groceryandbeveragesadvertise";
import GroceryTerms from "../Grocery/profilepages/GroceryTerms";
import GroceryRefund from "../Grocery/profilepages/GroceryRefund";
import { Link } from "react-router-dom";
import Groceryregistration from "./profilepages/Groceryregistration";
import { useNavigate } from "react-router-dom";

const Groceryprofiledata = () => {
    const [activeTab, setActiveTab] = useState("Registration");

    const [pricingData, setPricingData] = useState([]);
    const isMobile = window.innerWidth <= 768;
    const [orderPosts, setOrderPosts] = useState([]);


    const [isHovered, setIsHovered] = useState(false);

    const [subscriptions, setSubscriptions] = useState([]);

    const [vendorId, setVendorId] = useState(null);


    const navigate = useNavigate();
    const containerHeight = window.innerWidth < 768
        ? '750px'
        : window.innerWidth < 1350
            ? '405px'
            : '520px';

    const handleRedirect = () => {
        navigate("/subscriptionrenewal");
    };



    useEffect(() => {
        const storedVendorId = localStorage.getItem("vendorId");
        if (storedVendorId) {
            setVendorId(storedVendorId);
        }
    }, []);










    const [yearlyToggles, setYearlyToggles] = useState(
        pricingData.map(() => false)
    );


    useEffect(() => {
        const fetchSubscriptions = async () => {
            try {

                const vendorId = localStorage.getItem("vendorId"); // ✅ Retrieve vendorId https://backend.maamaas.com/food/subscriptions/user/
                const token = localStorage.getItem("authToken");
                if (!token || !vendorId) {
                    // console.warn("Missing token or vendorId");
                    return;
                }

                const response = await axios.get(
                    `https://backend.maamaas.com/food/subscriptions/subscriptions/${vendorId}/FRESH_GROCERIES`,
                    {
                        headers: {
                            Authorization: `Bearer ${token}`,
                            "Content-Type": "application/json",
                        },
                    }
                );

                // console.log("API Response:", response.data);

                const data = response.data;
                if (Array.isArray(data)) {
                    setSubscriptions(data);
                } else if (data && Array.isArray(data.subscriptions)) {
                    setSubscriptions(data.subscriptions);
                } else if (data) {
                    setSubscriptions([data]);
                } else {
                    setSubscriptions([]);
                }
            } catch (error) {
                console.error(
                    "Failed to fetch subscriptions:",
                    error.response?.data || error.message
                );
                setSubscriptions([]);
            }
        };

        fetchSubscriptions();
    }, []);


    const scrollContainerRef = useRef(null);

    useEffect(() => {
        const scrollContainer = scrollContainerRef.current;
        if (!scrollContainer) return;

        let interval;

        const startScrolling = () => {
            interval = setInterval(() => {
                if (!isHovered) {
                    scrollContainer.scrollTop += 1; // Scroll down smoothly

                    // Infinite loop logic
                    if (scrollContainer.scrollTop >= scrollContainer.scrollHeight / 2) {
                        scrollContainer.scrollTop = 0; // Reset to top for seamless loop
                    }
                }
            }, 20); // Adjust speed by changing interval
        }

        startScrolling();


        return () => clearInterval(interval);
    }, [isHovered]);






    const scrollRef = useRef(null);

    useEffect(() => {
        const container = scrollRef.current;
        if (!container) return;

        const scrollSpeed = 1; // px per tick
        const scrollInterval = 20; // ms
        let scroll;

        const startScroll = () => {
            scroll = setInterval(() => {
                container.scrollTop += scrollSpeed;

                // When scroll reaches half (original content height), reset to top for seamless loop
                if (container.scrollTop >= container.scrollHeight / 2) {
                    container.scrollTop = 0;
                }
            }, scrollInterval);
        };

        startScroll();

        return () => clearInterval(scroll);
    }, [orderPosts]);





    // {=======================overview===============================}
    const tabContent = {
        // "POS Billng": <Digialmenubillingspage />,


        Registration: <Groceryregistration onNext={() => {
            // console.log("Registration: Next clicked, changing to Terms And Conditions");
            setActiveTab("Terms And Conditions"); // Use the string key
        }} />,

        "Terms And Conditions": <GroceryTerms
            onNext={() => {
                // console.log("Terms: Next clicked, changing to Cancel/Refund");
                setActiveTab("Cancel/Refund"); // Use the string key
            }}
            onBack={() => { // Example for a back button
                // console.log("Terms: Back clicked, changing to Registration");
                setActiveTab("Registration");
            }}
        />,

        "Cancel/Refund": <GroceryRefund
            onFinish={() => { // Example for a finish button
                // console.log("Refund: Finish clicked, changing to Subscription");
                setActiveTab("Subscription"); // Go to another tab after finishing
            }}
            onBack={() => {
                // console.log("Refund: Back clicked, changing to Terms And Conditions");
                setActiveTab("Terms And Conditions");
            }}
        />,
        // ... other tabs

        Summary: (
            <div>
                {subscriptions.length === 0 ? (
                    <p>No subscriptions found.</p>
                ) : (
                    subscriptions.map((sub, index) => (
                        <table key={sub?.id || index} style={tableStyle}>
                            <thead>
                                <tr>
                                    <th style={headerStyle}>Field</th>
                                    <th style={headerStyle}>Value</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <td style={{ ...cellStyle, fontWeight: "bold" }}>Vendor ID</td>
                                    <td style={cellStyle}>
                                        {sub?.vendorEnquiry?.vendorId || "N/A"}
                                    </td>
                                </tr>
                                <tr>
                                    <td style={{ ...cellStyle, fontWeight: "bold" }}>Application</td>
                                    <td style={cellStyle}>
                                        <span
                                            style={{
                                                color: sub?.status ? "green" : "red",
                                                fontWeight: "bold",
                                            }}
                                        >
                                            {sub?.status ? "Approved" : "Pending"}
                                        </span>
                                    </td>
                                </tr>
                                <tr>
                                    <td style={{ ...cellStyle, fontWeight: "bold" }}>Status</td>
                                    <td style={cellStyle}>
                                        <span
                                            style={{
                                                color: sub?.status ? "green" : "red",
                                                fontWeight: "bold",
                                            }}
                                        >
                                            {sub?.status ? "Active" : "Inactive"}
                                        </span>
                                        <div style={{ marginTop: "-20px" }}>
                                            <button
                                                onClick={handleRedirect} // ✅ keep only one onClick
                                                style={{
                                                    backgroundColor: sub?.active ? "#4CAF50" : "#f44336",
                                                    color: "#fff",
                                                    border: "none",
                                                    borderRadius: "4px",
                                                    marginRight: "-120px",
                                                    padding: "5px 10px",
                                                    cursor: "pointer", // better UX
                                                }}
                                            >
                                                Upgrade
                                            </button>
                                        </div>

                                    </td>
                                </tr>
                                <tr>
                                    <td style={{ ...cellStyle, fontWeight: "bold" }}>
                                        Business Verticals
                                    </td>
                                    <td style={cellStyle}>{sub?.vendorEnquiry?.businessVerticals}</td>
                                </tr>
                                <tr>
                                    <td style={{ ...cellStyle, fontWeight: "bold" }}>Plan</td>
                                    <td style={cellStyle}>{sub?.subscriptionPlan?.planType}</td>
                                </tr>
                                <tr>
                                    <td style={{ ...cellStyle, fontWeight: "bold" }}>Start Date</td>
                                    <td style={cellStyle}>
                                        {sub?.startDate ? sub.startDate.slice(0, 10) : "N/A"}
                                    </td>
                                </tr>
                                <tr>
                                    <td style={{ ...cellStyle, fontWeight: "bold" }}>End Date</td>
                                    <td style={cellStyle}>
                                        {sub?.endDate ? sub.endDate.slice(0, 10) : "N/A"}
                                    </td>
                                </tr>
                                <tr>
                                    <td style={{ ...cellStyle, fontWeight: "bold" }}>Company Name</td>
                                    <td style={cellStyle}>{sub?.vendorEnquiry?.companyName}</td>
                                </tr>
                                <tr>
                                    <td style={{ ...cellStyle, fontWeight: "bold" }}>Owner Name</td>
                                    <td style={cellStyle}>{sub?.vendorEnquiry?.name}</td>
                                </tr>
                                <tr>
                                    <td style={{ ...cellStyle, fontWeight: "bold" }}>
                                        Phone Number
                                    </td>
                                    <td style={cellStyle}>{sub?.vendorEnquiry?.mobileNumber}</td>
                                </tr>
                                <tr>
                                    <td style={{ ...cellStyle, fontWeight: "bold" }}>Email</td>
                                    <td style={cellStyle}>{sub?.vendorEnquiry?.email}</td>
                                </tr>
                                <tr>
                                    <td style={{ ...cellStyle, fontWeight: "bold" }}>Pincode</td>
                                    <td style={cellStyle}>
                                        {sub?.vendorEnquiry?.pincode || "N/A"}
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    ))
                )}
            </div>

        ),

    };

    return (
        <>
            <div>
                <style>{`
        .main-container {
          padding: 20px;
          display: flex;
          flex-direction: column;
         
        }

         .tabs-wrapper {
          display: flex;
          flex-direction: column;
          align-items: center;
          gap: 10px;
          margin-left:0px;
}
// .left-column {
//             width: 100%;
//             padding-right: 140px;
//             max-height: 700px;
           
//           }


/* Mobile view ke liye (max-width 768px ya 600px aapke design ke hisaab se) */
@media screen and (max-width: 768px) {
  .tabs-wrapper {
    margin-left: 0;
    
  }
}


        .tab-buttons {
          display: flex;
          flex-wrap: wrap;
          justify-content: center;
          gap: 10px;
          margin-top:81px;
          padding:14px;
         
        }

        .tab-button {
          border: none;
          border-radius: 10px;
          width: 150px;
          height: 40px;
          background-color: #d9d9d9;
          color: #000;
          font-weight: bold;
          cursor: pointer;
          transition: background-color 0.3s ease;
        }

        .tab-button.active {
          background-color: #b15cd6;
        }

        .tab-content {
          margin-top: -10px;
          width: 100%;
          max-width:840px;
          
        }

        .sidebar {
          margin-top: 30px;
          max-height: 600px;
          overflow-y: auto;
        }

        .card {
          width: 100%;
          max-width: 300px;
          height: 120px;
          background: #ccc;
          border-radius: 8px;
          box-shadow: 0px 2px 4px rgba(0,0,0,0.1);
          margin: 10px auto;
          position: relative;
          padding: 10px;
        }

        .card h5, .card p {
          color: white;
          margin: -18 !imortanant;
        }

        

        
        @media (min-width: 768px) {
          .main-container {
            flex-direction: row;
            justify-content: space-between;
          }

          

          .left-column {
            width: 100%;
            padding-right: 95px;
            max-height: 700px;
           
          }

          .right-column {
            width: 30%;
            position: sticky;
            top: -30px;
            max-height: 700px;
            overflow-y: auto;
          }

          .card {
            margin-left: 0;
          }
            .tabs-wrapper{
            margin-left:none

            }
            .profile-mobilescroll{
            margin-top:119px!important;
            }

        }

        /* Hide native scrollbars */
        .sidebar::-webkit-scrollbar,
        .left-column::-webkit-scrollbar {
          width: 0px;
          background: transparent;
        }
      `}</style>

                {/* Main Layout */}
                <div className="container-fluid company-mobile-data">
                    <div className="row">
                        <div className="col-lg-2"></div>
                        <div className="col-lg-7">

                            <p
                                className="breadcrumb maamaas-home-bredcum"
                                style={{
                                    position: "fixed",
                                    top: isMobile ? "50px" : "80px",
                                    left: isMobile ? "5px" : "275px",
                                    width: "100%",
                                    backgroundColor: "#fff",
                                    zIndex: 1000,
                                    padding: "10px 0",
                                    fontSize: isMobile ? "14px" : "18px",
                                    fontWeight: isMobile ? "normal" : "bold",
                                    textAlign: "center",
                                    margin: 0,
                                }}
                            >
                                <Link
                                    to="/Newmainlandingpage"
                                    style={{
                                        color: "purple",
                                        fontWeight: "bold",
                                        textDecoration: "none",
                                    }}
                                >
                                    Home
                                </Link>

                                <span className="separator"> &gt; </span>
                                <Link
                                    to="/foodladingpage"
                                    style={{
                                        color: "purple",
                                        fontWeight: "bold",
                                        textDecoration: "none",
                                    }}
                                >
                                    Fresh & Groceries

                                </Link>

                                <span className="separator"> &gt; </span>
                                <Link

                                    style={{
                                        color: "purple",
                                        fontWeight: "bold",
                                        textDecoration: "none",
                                    }}
                                >
                                    Profile
                                </Link>
                            </p>



                            {/* Left Section */}
                            <div className="profile-mobilescroll">
                                <div >

                                    <div className="tab-buttons" style={{}}>
                                        {Object.keys(tabContent).map((label) => (
                                            <button
                                                key={label}
                                                className={`tab-button ${activeTab === label ? "active" : ""}`}
                                                onClick={() => setActiveTab(label)}
                                            >
                                                {label}
                                            </button>
                                        ))}
                                    </div>
                                    <div
                                        className="tab-content"
                                        style={{
                                            overflow: 'auto',
                                            height: containerHeight,
                                            scrollbarWidth: "none",
                                            msOverflowStyle: "none",
                                            maxWidth: '944px',
                                        }}
                                    >
                                        {tabContent[activeTab]}
                                    </div>
                                </div>
                            </div>


                        </div>
                        <div className="col-lg-3">
                            <Groceryandbeveragesadvertise />
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

const tableHeaderStyle = {
    border: "1px solid #ddd",
    textAlign: "center",
    fontWeight: "bold",
    backgroundColor: "#b15cd6",
    color: "white",
};



const evenRowStyle = {

};

const oddRowStyle = {

};
const rowStyle = {
    borderBottom: "1px solid #ccc",
    padding: "8px",
};
const inputStyle = {
    width: "100%",
    border: "none",
    backgroundColor: "transparent",
    textAlign: "center",
};
const buttonStyle = {
    backgroundColor: "#dc3545",
    color: "white",
    border: "none",
    borderRadius: "4px",
    cursor: "pointer",
    marginRight: "5px",
};
const buttonStyle1 = {
    backgroundColor: "green",
    color: "white",
    border: "none",
    borderRadius: "4px",
    cursor: "pointer",
    marginRight: "5px",
};
const addButtonStyle = {
    marginBottom: "10px",

    backgroundColor: "#b15cd6",
    color: "white",
    border: "none",
    cursor: "pointer",
    borderRadius: "5px",
    width: "100px",
};
const tableStyle = {
    width: "100%",
    borderCollapse: "collapse",
    marginBottom: "30px",
    border: "1px solid #ddd",
};

const headerStyle = {
    backgroundColor: "#b15dc6",
    padding: "10px",
    border: "1px solid #ccc",
    textAlign: "Center",
    fontWeight: "bold"
};

const cellStyle = {
    padding: "10px",
    border: "1px solid #ccc",
};

const deleteButtonStyle = {
    backgroundColor: "red",
    color: "white",
    border: "none",
    padding: "5px 10px",
    cursor: "pointer",
    borderRadius: "5px",
};
const iconButtonStyle = {
    backgroundColor: "transparent",
    border: "none",
    cursor: "pointer",
    fontSize: "18px",
    marginRight: "8px",
    color: "#333",
};

const modalOverlayStyle = {
    position: "fixed",
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: "rgba(0,0,0,0.5)",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    zIndex: 1000,
};

const modalContentStyle = {
    backgroundColor: "#fff",
    padding: "20px",
    borderRadius: "10px",
    minWidth: "300px",
    boxShadow: "0px 0px 10px rgba(0,0,0,0.2)",
};




export default Groceryprofiledata;

